import { ActionInputProps } from '../../../components/action-input';

export const getContextProps = (props: Omit<ActionInputProps, 'children'>) => {
	const {
		budget,
		context,
		isSubmitting,
		modules = [],
		onSubmit,
		onValidationError,
		validator,
		isLoadingAttachment,
		cancelVideoGeneration,
		wrapPost,
		setWrapPost,
	} = props;

	return {
		budget,
		context,
		isSubmitting,
		modules,
		onSubmit,
		isLoadingAttachment,
		onValidationError,
		validator,
		cancelVideoGeneration,
		wrapPost,
		setWrapPost,
	};
};
